import content from "app-content";
import HomeButton from "../HomeButton";
import InitialisationError from "../InitialisationError";

const SdkError = () => (
  <InitialisationError
    title={content.saved_items_pageload_error_after_3_header}
    messages={[
      content.saved_items_api_failure_full_page_error1,
      content.saved_items_api_failure_full_page_error2
    ]}
    Button={HomeButton}
  />
);

export default SdkError;
